
export enum DeliveryRatingActionTypes {
  RATING_VALIDATE = '@@DeliveryRating/RATING_VALIDATE',
  RATING_VALIDATE_RESPONSE = '@@DeliveryRating/RATING_VALIDATE_RESPONSE',
  RATING_VALIDATE_FAILED = '@@DeliveryRating/RATING_VALIDATE_FAILED',
  RATING_CREATE = '@@DeliveryRating/RATING_CREATE',
  RATING_CREATE_RESPONSE = '@@DeliveryRating/RATING_CREATE_RESPONSE',

}

export interface DeliveryRatingState {
  loading: boolean;
  isValid: boolean;
  isSent: boolean;
}
